var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "account-information-destination-field" }, [
    _c("div", { staticClass: "account-information-destination-field-label" }, [
      _c("span", {
        staticClass: "destination-name",
        domProps: { textContent: _vm._s(_vm.interest.label) },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "account-information-destination-field-action" }, [
      !_vm.isLoading
        ? _c(
            "button",
            {
              staticClass: "account-information-field-cta__remove",
              attrs: {
                href: "#",
                "aria-label":
                  _vm.remove + " " + _vm.label + ": " + _vm.interest.label,
                disabled: _vm.isUpdateProfilePending,
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.removeItem($event)
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.removeItem($event)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.remove) + "\n    ")]
          )
        : _c("span", { staticClass: "icon-loading-black" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }